export { default } from "./TablePlaceholder";
